// src
import config from "config";
import { networkError } from "actions/system";
import { disconnect } from "actions/user";

const getResourceAndOptions = (req) => {
  if (typeof req === "string") return [req, null];
  const { resource, ...options } = req;
  return [resource, options];
};

const request = async (
  req,
  dispatch,
  getState,
  requestCallback,
  successCallback,
  failureCallback,
) => {
  try {
    const [resource, options] = getResourceAndOptions(req);
    const { token } = getState().user;
    const headers = { "Content-type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;

    if (requestCallback) requestCallback();
    const res = await fetch(`${config.backRoot}${resource}`, { headers, ...options });

    if (res.status === 401) {
      dispatch(disconnect());
    } else if (res.ok) {
      const contentType = res.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        successCallback(await res.json());
      } else {
        successCallback();
      }
    } else {
      if (failureCallback) failureCallback(res.status);
      // used to display a warning
      dispatch(networkError());
    }
  } catch (err) {
    dispatch(networkError());
    console.error(err);
  }
};

export default { request };
